export var Scroller = function (x, y) {
  if (x === void 0) {
    x = 0;
  }
  if (y === void 0) {
    y = 0;
  }
  setTimeout(function () {
    return window.scrollTo(x, y);
  });
};